  export const redFlagAlertOptions = [
    { value: "keep", label: "Condition remains part of Assessment."},
    { value: "override", label: "Condition not part of Assessment; suboptimal."},
    { value: "delete", label: "Delete condition; no longer exists."},
  ];